import createIcon from "./createIcon";

export const ChevronLeftIcon = createIcon('ChevronLeft', (props) => {
  return (
    <svg {...props} viewBox="0 0 24 24">
      <defs>
        <filter id="pixso_custom_mask_type_alpha">
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
        </filter>
      </defs>
      <mask
        id="mask_4"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <g filter="url(#pixso_custom_mask_type_alpha)">
          <rect
            width="24"
            height="24"
            fill="currentColor"
            transform="matrix(0,1,-1,0,24,0)"
          />
        </g>
      </mask>
      <g mask="url(#mask_4)">
        <g transform="matrix(0,1,-1,0,16.999,2.99951)">
          <path
            d="M2.13048 0.36553C1.64309 -0.121843 0.852904 -0.121843 0.36553 0.36553C-0.121842 0.852903 -0.121842 1.64309 0.36553 2.13047L2.13048 0.36553ZM8.736 8.736L7.85353 9.61847C8.34091 10.1058 9.1311 10.1058 9.61848 9.61847L8.736 8.736ZM17.1065 2.13047C17.5938 1.64309 17.5938 0.852903 17.1065 0.36553C16.6191 -0.121843 15.8289 -0.121843 15.3415 0.36553L17.1065 2.13047ZM0.36553 2.13047L7.85353 9.61847L9.61848 7.85352L2.13048 0.36553L0.36553 2.13047ZM9.61848 9.61847L17.1065 2.13047L15.3415 0.36553L7.85353 7.85352L9.61848 9.61847Z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  )
});